import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { AgGridAngular } from "ag-grid-angular";
import { BehaviorSubject, Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { SubSink } from "subsink2";

@Component({
  selector: 'app-pagination-client-side-v3',
  templateUrl: './pagination-client-side-v3.component.html',
  styleUrls: ['./pagination-client-side-v3.component.css']
})
export class PaginationClientSideV3Component implements OnInit {
  @Input() agGridReference: AgGridAngular;
  @Input() totalRecords$: Observable<number>;
  @Output() onMorePageClick = new EventEmitter<any>();
  @Output() nextListing = new EventEmitter<any>();
  @Output() onRowsChange = new EventEmitter<any>();
  @Output() previousListing = new EventEmitter<any>();

  private subs = new SubSink();

  rowPerPage = 25;
  currentPage: number;
  totalPage: BehaviorSubject<number>;
  getRowClass = (params) => {
    if (params.node.rowIndex % 2 === 1) {
      return "ag-grid-odd-rows";
    }
    return "";
  };
  showMorePage: boolean = false;
  disablePreviousButton: boolean = true;
  disableNextButton: boolean;
  totalRecords: number;

  constructor(private cdr: ChangeDetectorRef) {
    this.currentPage = 1;
    this.totalPage = new BehaviorSubject<number>(1);
  }

  ngOnInit() {
    this.subs.sink = this.agGridReference.gridReady
      .pipe(
        map(() => this.agGridReference.api.paginationGetTotalPages()),
        map((b) => (b ? this.totalPage.next(b) : this.totalPage.next(1))),
        switchMap(() => this.agGridReference.paginationChanged.asObservable()),
        map(() => this.agGridReference.api.paginationGetTotalPages())
      )
      .subscribe((resolve) => {});

    this.subs.sink = this.totalRecords$.subscribe((totalRecords) => {
      // Calculate the new total page count.
      const newTotalPages = Math.ceil(totalRecords / this.rowPerPage);

      this.totalRecords = totalRecords;
      this.totalPage.next(newTotalPages);

      this.currentPage = 1;

      // Update button states
      this.updateButtonStates();
    });
  }

  onRowChange(row: number) {
    this.rowPerPage = row;
    const newTotalPages = Math.ceil(this.totalRecords / this.rowPerPage);
    this.totalPage.next(newTotalPages);
    this.currentPage = 1;
    this.updateButtonStates();
    this.agGridReference.api.paginationSetPageSize(row);
    this.currentPage = this.agGridReference.api.paginationGetCurrentPage() + 1;
    if (row > 5) {
      this.agGridReference.api.setDomLayout("normal");
    } else {
      this.agGridReference.api.setDomLayout("autoHeight");
    }
    this.onRowsChange.emit();
  }

  nextPage() {
    if (!this.disableNextButton) {
      this.agGridReference.api.paginationGoToNextPage();
      this.currentPage++;

      // Update button states
      this.updateButtonStates();

      this.nextListing.emit();
    }
  }

  previousPage() {
    if (!this.disablePreviousButton) {
      this.agGridReference.api.paginationGoToPreviousPage();
      this.currentPage = this.currentPage > 1 ? this.currentPage - 1 : 1;

      // Update button states
      this.updateButtonStates();

      this.previousListing.emit();
    }
  }

  // Add this method to update button states
  updateButtonStates() {
    this.disableNextButton = this.currentPage === this.totalPage.getValue();
    this.disablePreviousButton = this.currentPage === 1;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
